module.exports = __webpack_public_path__ + "static/img/popup-icon.a4a84ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/popup-icon.png
// module id = 3t+I
// module chunks = 1